module.exports = __webpack_public_path__ + "static/img/8.9aac722.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/8/1/2/eng/8.png
// module id = LDlo
// module chunks = 0